import { IGadget } from '../../data/types/ship/gadget/gadget';
import { GadgetConfig } from '../../data/types/ship/gadget/gadget-config';
import { gadgetConfigs } from './gadget.configs';
import memoize from 'fast-memoize';

export const getGadgetConfig = memoize(
  (gadget: IGadget): GadgetConfig => gadgetConfigs[gadget.type],
);
